import { MiddlewareContext } from '.'
import { useProducerStore } from '@/stores/producer'

/**
 * Verify the necessity of a producer on guarded routes
 *
 * @param context `MiddlewareContext`
 * @returns `Promise<void>`
 */
export function producer(context: MiddlewareContext) {
  const store = useProducerStore()

  if (!context.to.meta.needsProducer || store.producer) {
    return context.next()
  }

  if (store.producers.length === 0) {
    return context.next('/login')
  }

  if (store.producers.length > 1) {
    return context.next('/producers')
  }

  store.setProducer(store.producers[0])

  return context.next()
}
